/**
 * DB printing label (projects.printing_type.type) -> mockup-generator value.
 * null = not supported by mockup generator.
 * Keep in sync with swageazy/src/utils/printingType.ts
 */

export const PRINTING_TYPES: Record<string, string | null> = {
  "UV Single Colour": "UV Print",
  "UV Multi Colour": "UV Print",
  "Laser Engraving": "Laser",
  Sublimation: "Sublimation",
  DTF: "DTF",
  DTG: "DTG",
  Screen: "Screen print",
  "Custom Sticker": null,
  Embroidery: "Embroidery",
  Etching: "Laser",
  // Legacy / alternate labels
  "DTF(Direct-to-film)": "DTF",
  "DTG(Direct-to-garment)": "DTG",
  "Screen print": "Screen print",
  "UV Print": "UV Print",
  Laser: "Laser",
  Debossing: "Debossing",
  Embossing: "Embossing",
};

const MOCKUP_PRINTING_TYPE_VALUES = new Set(
  Object.values(PRINTING_TYPES).filter(
    (value): value is string => value !== null,
  ),
);

function lookupPrintingType(raw: string): string | null | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;

  if (Object.prototype.hasOwnProperty.call(PRINTING_TYPES, trimmed)) {
    return PRINTING_TYPES[trimmed];
  }

  const caseInsensitiveKey = Object.keys(PRINTING_TYPES).find(
    (key) => key.toLowerCase() === trimmed.toLowerCase(),
  );
  if (caseInsensitiveKey) {
    return PRINTING_TYPES[caseInsensitiveKey];
  }

  return undefined;
}

export function normalizePrintingType(raw: string): string | null {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return null;

  const mapped = lookupPrintingType(trimmed);
  if (mapped !== undefined) return mapped;

  const parenPrefix = trimmed.match(/^([^(]+)\(/)?.[1]?.trim();
  if (parenPrefix) {
    const fromParen = lookupPrintingType(parenPrefix);
    if (fromParen !== undefined) return fromParen;
  }

  const exactMatch = Array.from(MOCKUP_PRINTING_TYPE_VALUES).find(
    (value) => value.toLowerCase() === trimmed.toLowerCase(),
  );
  if (exactMatch) return exactMatch;

  return null;
}
